document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form.contact-form-tb__form');
  if (!form) return;

  const errorBox = form.querySelector('.contact-form-tb__button__error');
  const successBox = form.querySelector('.contact-form-tb__button__success');

  const showErrorBox = () => {
    if (errorBox) {
      errorBox.classList.add('show');
      setTimeout(() => {
        errorBox.classList.remove('show');
      }, 5000); 
    }
  };
  
  const showSuccessBox = () => {
    if (successBox) {
      successBox.classList.add('show');
      setTimeout(() => {
        successBox.classList.remove('show');
      }, 5000);
    }
  };
  

  const resetFeedbackMessages = () => {
    if (errorBox) errorBox.classList.remove('show');
    if (successBox) successBox.classList.remove('show');
  };

  const highlightErrors = (errors) => {
    form.querySelectorAll('.is-invalid').forEach(el => el.classList.remove('is-invalid'));
    form.querySelectorAll('.contact-form-tb__field__error').forEach(el => {
      el.classList.remove('show');
    });

    for (const field in errors) {
      const input = form.querySelector(`[name="${field}"], [name*="${field}"]`);
      if (input) {
        input.classList.add('is-invalid');

        const fieldWrapper = input.closest('.field');
        const errorMsg = fieldWrapper?.querySelector('.contact-form-tb__field__error');
        if (errorMsg) {
          errorMsg.classList.add('show');
        }
      }
    }
  };

  const enableRealTimeValidation = () => {
    form.querySelectorAll('input, select, textarea').forEach((field) => {
      const hideError = () => {
        field.classList.remove('is-invalid');
        const wrapper = field.closest('.field');
        const errorMsg = wrapper?.querySelector('.contact-form-tb__field__error');
        if (errorMsg) {
          errorMsg.classList.remove('show');
        }
      };
      field.addEventListener('input', hideError);
      field.addEventListener('change', hideError);
    });
  };

  enableRealTimeValidation();

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    resetFeedbackMessages();

    const token = form.querySelector('input[name="token"]')?.value;
    if (!token) {
      showErrorBox();
      return;
    }

    // Genera token reCAPTCHA
    try {
      const recaptchaToken = await new Promise((resolve, reject) => {
        grecaptcha.ready(() => {
          grecaptcha.execute('6Lcm4OgrAAAAADWgepShuQDu4kEnLHCpl7jvKUfn', {action: 'contact'})
            .then(resolve)
            .catch(reject);
        });
      });
      
      // Imposta il token reCAPTCHA nel form
      const recaptchaInput = form.querySelector('input[name="recaptcha_token"]');
      if (recaptchaInput) {
        recaptchaInput.value = recaptchaToken;
      }
    } catch (error) {
      console.error('reCAPTCHA error:', error);
      showErrorBox();
      return;
    }

    const formData = new FormData(form);

    // Rimuoviamo la logica data-email dato che ora inviamo sempre a customercare@burago.com

    // Usa il nome del campo reale per leggere lo stato della checkbox
    formData.set('privacy1', form.querySelector('input[name="privacy1"]')?.checked ? '1' : '0');
    formData.set('register_customer', form.querySelector('#register_customer')?.checked ? '1' : '0');

    const fileInput = form.querySelector('input[name="attach_file"]');
    if (!fileInput || fileInput.files.length === 0) {
      formData.delete('attach_file');
    }

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: {
          'X-APP-KEY': token,
          'Accept': 'application/json'
        },
        body: formData
      });

      const result = await response.json();

      if (response.ok) {
        form.reset();
        showSuccessBox();
      } else {
        if (result.errors) {
          highlightErrors(result.errors);
        } else {
          showErrorBox();
        }
      }
    } catch (err) {
      showErrorBox();
    }
  });
});